import {Button, CircularProgress} from '@material-ui/core';
import classNames from 'classnames';
import {AsyncPage, isLoadedPage} from 'Core/models/Async';
import {Page} from 'Core/models/Page';
import React, {useState} from 'react';
import 'Shared/components/PagedView/Card/CardFilterOverlay.sass';
import getFilterComponent, {FilterProperties} from 'Shared/components/PagedView/Filter';

export type CardFilters<TFilter> = {
  filter: FilterProperties<TFilter>;
  title: string;
};

type CardFilterOverlayProps<TData, TFilter> = {
  filters: Array<CardFilters<TFilter>>;
  data: AsyncPage<Page<TData>>;
  open: boolean;
  onClose: () => void;
};

const CardFilterOverlay = <TData, TFilter>(props: CardFilterOverlayProps<TData, TFilter>) => {
  const [isFakeClosed, setIsFakeClosed] = useState(false);

  const FilterComponents = props.filters.map(({title, filter}) => getFilterComponent(title, filter));

  return props.open ? (
    <div
      className={classNames('card-filter-overlay', {
        slideClosed: isFakeClosed,
        slideIn: !isFakeClosed,
      })}
    >
      <div className="card-filter-overlay__header">
        {isLoadedPage(props.data) ? (
          <span>
            Total Results: <strong>{props.data.Data.totalCount}</strong>
          </span>
        ) : (
          <CircularProgress color="secondary" />
        )}
      </div>
      <div className="card-filter-overlay__content">{FilterComponents}</div>
      <div className="card-filter-overlay__actions-section">
        <Button
          className="card-filter-overlay__close-button"
          fullWidth
          color="primary"
          variant="contained"
          onClick={() => {
            setIsFakeClosed(true);
            setTimeout(() => {
              props.onClose();
              setIsFakeClosed(false);
            }, 1000);
          }}
        >
          View Results
        </Button>
      </div>
    </div>
  ) : null;
};

export default CardFilterOverlay;
